var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file [Please Input File Description]
 * @author (zhaojun10)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Pagination.less';
import classnames from 'classnames';
import { classPrefix } from '../../common/util';

import PerPage from './PerPage';

/**
 * 参数说明
 * perPage           必需，每页显示多少
 * current           必需，当前活跃的页数
 * onChange          必需，回调函数
 * totalItem         必需，totalItem和totalPage二选一，总条数
 * totalPage         必需，totalItem和totalPage二选一，总页数
 * perItem           可选，每页显示多少的数组
 * perFlag           可选，是否带每页显示多少条功能，默认不带，此值为bool类型
 * skipFlag          可选，是否带跳到多少页功能，默认不带，此值为bool类型
 * totalFlag         可选，是否单独显示总个数，默认不带，此值为bool类型（如果享用，必须传totalItem)
 * largeSize         可选，增加间距为40px
 * size              可选，增加间距为默认值,largeSize和size并存时，以size为准
 * interval          可选，每两次点击的间隔时间，默认1秒
 */

var PageView = function (_Component) {
    _inherits(PageView, _Component);

    function PageView() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PageView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageView.__proto__ || Object.getPrototypeOf(PageView)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, _this.props, {
            onChange: null,
            perItem: _this.props.perItem.length ? _this.props.perItem : [10, 20, 30, 50],
            skip: _this.props.current || 1
        }), _this.time = null, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PageView, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            this.setState(function () {
                return _extends({}, newProps, {
                    onChange: null,
                    perItem: newProps.perItem.length > 0 ? newProps.perItem : [10, 20, 30, 50],
                    skip: newProps.current || 1
                });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }, {
        key: 'pageChange',
        value: function pageChange(e) {
            var _this2 = this;

            var t = void 0;
            var _state = this.state,
                perPage = _state.perPage,
                current = _state.current,
                totalItem = _state.totalItem,
                totalPage = _state.totalPage,
                interval = _state.interval;

            if (this.timer) {
                return false;
            } else {
                this.timer = setTimeout(function () {
                    clearTimeout(_this2.timer);
                    _this2.timer = null;
                }, interval === undefined ? 1000 : interval);
            }
            if (totalPage) {
                t = totalPage;
            } else if (totalItem) {
                t = totalItem % perPage === 0 ? parseInt(totalItem / perPage, 10) : parseInt(totalItem / perPage, 10) + 1;
            } else {
                t = 0;
            }
            if (t <= 1) {
                return;
            }
            if (e + '' === current + '') {
                return;
            }
            if (e + '' === 'previous') {
                if (current === 1) {
                    return;
                }
                this.props.onChange({
                    current: current - 1,
                    perPage: perPage
                });
                this.setState(function () {
                    return {
                        current: current - 1,
                        perPage: perPage
                    };
                });
            } else if (e + '' === 'next') {
                if (current === totalPage) {
                    return;
                }
                this.props.onChange({
                    current: current + 1,
                    perPage: perPage
                });
                this.setState(function () {
                    return {
                        current: current + 1,
                        perPage: perPage
                    };
                });
            } else {
                this.props.onChange({ current: e, perPage: perPage });
                this.setState(function () {
                    return { current: e, perPage: perPage };
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this3 = this;

            var t = void 0;
            var arr = [];
            var perList = void 0;
            var sizeStyle = void 0;
            var _props = this.props,
                className = _props.className,
                classPrefix = _props.classPrefix;

            var rootClassName = classnames((_classnames = {}, _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, classPrefix + '-pagination', true), _classnames));
            var _state2 = this.state,
                perPage = _state2.perPage,
                current = _state2.current,
                totalItem = _state2.totalItem,
                totalPage = _state2.totalPage,
                perItem = _state2.perItem,
                perFlag = _state2.perFlag,
                skipFlag = _state2.skipFlag,
                totalFlag = _state2.totalFlag,
                largeSize = _state2.largeSize,
                size = _state2.size;

            var c = current;

            if (totalPage) {
                t = totalPage;
            } else if (totalItem) {
                t = totalItem % perPage === 0 ? parseInt(totalItem / perPage, 10) : parseInt(totalItem / perPage, 10) + 1;
            } else {
                t = 0;
            }
            if (t === 0) {
                return React.createElement('div', null);
            }
            if (perFlag) {
                perList = perItem.map(function (value, index) {
                    var perClass = classnames({
                        'per-blue': perPage + '' === value + ''
                    });
                    return React.createElement(
                        'li',
                        { className: perClass, key: 'per-page-arr-' + index },
                        value
                    );
                });
            }
            if (t <= 9 && c <= 9) {
                arr.push('上一页');
                for (var i = 1; i <= t; i++) {
                    arr.push(i);
                }
                arr.push('下一页');
            } else if (t > 9 && c <= 5) {
                arr = ['上一页', 1, 2, 3, 4, 5, 6, 7, '...', t, '下一页'];
            } else if (t > 9 && c >= t - 4) {
                arr = ['上一页', 1, '...', t - 6, t - 5, t - 4, t - 3, t - 2, t - 1, t, '下一页'];
            } else if (t > 9 && c > 5 && c < t - 4) {
                arr = ['上一页', 1, '...', c - 2, c - 1, c, c + 1, c + 2, '...', t, '下一页'];
            }
            var previousClass = classnames({
                'page-previous': true,
                'page-previous1': c === 1
            });
            var nextClass = classnames({
                'page-next': true,
                'page-next1': c === t
            });
            if (size && typeof size === 'number') {
                sizeStyle = {
                    marginRight: +size
                };
            } else if (largeSize) {
                sizeStyle = {
                    marginRight: 40
                };
            } else {
                sizeStyle = {};
            }
            var pages = arr.map(function (value, i) {
                if (value === '上一页') {
                    return React.createElement(
                        'li',
                        {
                            className: previousClass,
                            style: sizeStyle,
                            key: 'page-' + i,
                            onClick: function onClick() {
                                c !== 1 && _this3.pageChange('previous');
                            }
                        },
                        '\u4E0A\u4E00\u9875'
                    );
                } else if (value === '下一页') {
                    return React.createElement(
                        'li',
                        {
                            className: nextClass,
                            key: 'page-' + i,
                            style: sizeStyle,
                            onClick: function onClick() {
                                c !== t && _this3.pageChange('next');
                            }
                        },
                        '\u4E0B\u4E00\u9875'
                    );
                } else if (value === '...') {
                    return React.createElement(
                        'li',
                        { key: 'page-' + i, style: sizeStyle },
                        '\xB7\xB7\xB7'
                    );
                } else if (value + '' === c + '') {
                    return React.createElement(
                        'li',
                        {
                            className: classnames(['active', classPrefix + '-pager-pages']),
                            key: 'page-' + i,
                            style: sizeStyle,
                            onClick: function onClick() {
                                _this3.pageChange(value);
                            }
                        },
                        React.createElement(
                            'span',
                            { className: classPrefix + '-pager-hover' },
                            value
                        )
                    );
                } else {
                    return React.createElement(
                        'li',
                        {
                            key: 'page-' + i,
                            className: classPrefix + '-pager-pages',
                            style: sizeStyle,
                            onClick: function onClick() {
                                _this3.pageChange(value);
                            }
                        },
                        React.createElement(
                            'span',
                            { className: classPrefix + '-pager-hover' },
                            value
                        )
                    );
                }
            });
            if (totalItem && totalFlag) {
                pages.push(React.createElement(
                    'li',
                    { key: 'page-total', className: 'margin28', style: sizeStyle },
                    '共' + totalItem + '项'
                ));
            }
            if (perFlag) {
                pages.push(React.createElement(PerPage, {
                    key: 'page-per',
                    perPage: perPage,
                    sizeStyle: sizeStyle,
                    perList: perList,
                    onChange: function onChange(e) {
                        e.stopPropagation();
                        var html = e.target.innerHTML;
                        _this3.setState(function () {
                            return {
                                perPage: +html,
                                current: 1
                            };
                        });
                        _this3.props.onChange({
                            current: 1,
                            perPage: +html
                        });
                    }
                }));
            }
            if (skipFlag) {
                pages.push(React.createElement(
                    'li',
                    { key: 'page-skip', className: 'skips', style: sizeStyle },
                    React.createElement(
                        'div',
                        {
                            style: {
                                cursor: 'default'
                            }
                        },
                        '\u8DF3\u81F3'
                    ),
                    React.createElement(
                        'div',
                        { className: 'skip' },
                        React.createElement('input', {
                            type: 'text',
                            value: this.state.skip,
                            onKeyDown: function onKeyDown(e) {
                                e.stopPropagation();
                                var key = e.keyCode || e.which;
                                var value = +e.target.value;
                                if (value === c) {
                                    return;
                                }
                                if (key === 13) {
                                    if (value <= t && value >= 1 && value !== c && /\d*/g.test(value + '')) {
                                        _this3.pageChange(parseInt(value, 10));
                                    }
                                }
                            },
                            onChange: function onChange(e) {
                                var value = e.target.value;
                                _this3.setState(function () {
                                    return { skip: value };
                                });
                            }
                        })
                    ),
                    React.createElement(
                        'div',
                        {
                            style: {
                                cursor: 'default'
                            }
                        },
                        '\u9875'
                    )
                ));
            }
            return React.createElement(
                'div',
                { className: rootClassName },
                React.createElement(
                    'ul',
                    { className: 'page-main' },
                    pages
                )
            );
        }
    }]);

    return PageView;
}(Component);

PageView.defaultProps = {
    perItem: [10, 20, 30, 50],
    perFlag: true,
    classPrefix: classPrefix
};
PageView.propTypes = {
    perPage: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    totalItem: PropTypes.number,
    totalPage: PropTypes.number,
    perItem: PropTypes.array,
    perFlag: PropTypes.bool,
    skipFlag: PropTypes.bool,
    totalFlag: PropTypes.bool,
    largeSize: PropTypes.number,
    size: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    interval: PropTypes.number,
    classPrefix: PropTypes.string,
    className: PropTypes.string
};
export default PageView;